<template>
  <div>
    <Card>
      <Row>
        <Button type="info" @click="add">{{
          $t("pages_wechat_configs_index_1148")
        }}</Button>
        <iframe
          ref="iframe"
          border="none"
          :src="`//${iframeUrl}/wechat_auth.html`"
        >
        </iframe>
      </Row>
      <br />
      <Row>
        <Col span="12">appid</Col>
        <Col span="12">{{ wechat_config.appid }}</Col>
      </Row>
      <br />
      <Row>
        <Col span="12">secret</Col>
        <Col span="12">{{ wechat_config.secret }}</Col>
      </Row>
    </Card>
    <Card style="margin-top: 12px">
      <div slot="title">
        {{ $t("pages_wechat_configs_index_1149") }}
        <!-- <Button v-if="wxaAuthorized"
                type="primary"
                style="margin-left: 8px"
                @click="onEditWxa">修改</Button> -->
      </div>
      <div v-if="wxaAuthorized">
        <Form colon>
          <Form-Item :label="$t('pages_wechat_configs_index_1150')">
            {{
              wxa_wechat.storeable_name || $t("pages_wechat_configs_index_1151")
            }}
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1152')">
            {{
              wxa_wechat.storeable_type === "Shop"
                ? $t("pages_wechat_configs_index_1153")
                : $t("pages_wechat_configs_index_1154") ||
                  $t("pages_wechat_configs_index_1151")
            }}
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1155')">
            {{
              wxa_wechat.wechat_shop_name ||
              $t("pages_wechat_configs_index_1151")
            }}
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1156')">
            {{ wxa_wechat.nick_name || $t("pages_wechat_configs_index_1151") }}
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1157')">
            {{
              wxa_wechat.principal_name || $t("pages_wechat_configs_index_1151")
            }}
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1158')">
            {{
              wxa_wechat.wechat_slogan || $t("pages_wechat_configs_index_1151")
            }}
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1159')">
            <img
              v-if="wxa_wechat.head_img"
              :src="wxa_wechat.head_img"
              style="width: 100px"
            />
            <span v-else>{{ $t("pages_wechat_configs_index_1151") }}</span>
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1160')">
            <img
              v-if="wxa_wechat.background_image"
              :src="wxa_wechat.background_image"
              style="width: 100px"
            />
            <span v-else>{{ $t("pages_wechat_configs_index_1151") }}</span>
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1161')">
            <div
              v-if="wxa_wechat.theme"
              :style="`vertical-align: middle;background-color: ${wxa_wechat.theme}; width: 20px; height: 20px;display: inline-block;`"
            ></div>
            {{ wxa_wechat.theme ? "" : $t("pages_wechat_configs_index_1151") }}
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1162')">
            {{
              !!wxa_wechat.is_verified
                ? $t("libs_table_render_50")
                : $t("directives_index_41") ||
                  $t("pages_wechat_configs_index_1151")
            }}
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1163')">
            {{
              wxa_wechat.created_at_str || $t("pages_wechat_configs_index_1151")
            }}
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1164')">
            {{
              wxa_wechat.authorizer_appid ||
              $t("pages_wechat_configs_index_1151")
            }}
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1165')">
            {{
              wxa_wechat.authorizer_secret ||
              $t("pages_wechat_configs_index_1151")
            }}
          </Form-Item>
          <Form-Item :label="$t('pages_wechat_configs_index_1166')">
            {{ wxa_wechat.user_name || $t("pages_wechat_configs_index_1151") }}
          </Form-Item>
          <!-- <Form-Item>
            <Button v-if="wxaAuthorized"
                    type="primary"
                    style="margin-left: 8px"
                    @click="onEditWxa">修改</Button>
          </Form-Item> -->
        </Form>
      </div>
      <div v-else class="exa_empty">
        <h2>{{ $t("pages_wechat_configs_index_1167") }}</h2>
      </div>
    </Card>
    <Modal
      v-model="modalShow"
      @on-ok="handleSubmit"
      :title="$t('pages_wechat_configs_index_1168')"
    >
      <Form ref="wechat_config" :model="wechat_config" :label-width="80">
        <Form-item label="appid" prop="appid">
          <Input type="text" v-model="wechat_config.appid" />
        </Form-item>
        <Form-item label="secret" prop="secret">
          <Input type="text" v-model="wechat_config.secret" />
        </Form-item>
      </Form>
    </Modal>
    <Modal
      v-model="showWxaModal"
      @on-ok="handleSubmitWxa"
      :title="$t('pages_wechat_configs_index_1169')"
    >
      <Form ref="wxa_wechat" :model="wxaForm" :label-width="80">
        <Form-item
          :label="$t('pages_wechat_configs_index_1170')"
          prop="authorizer_secret"
        >
          <Input
            type="text"
            v-model="wxaForm.authorizer_secret"
            :placeholder="$t('pages_wechat_configs_index_1171')"
          />
        </Form-item>
        <Form-item
          :label="$t('pages_wechat_configs_index_1172')"
          prop="wechat_shop_name"
        >
          <Input
            type="text"
            v-model="wxaForm.wechat_shop_name"
            :placeholder="$t('pages_wechat_configs_index_1173')"
          />
        </Form-item>
        <Form-item
          :label="$t('pages_wechat_configs_index_1174')"
          prop="wechat_slogan"
        >
          <Input
            type="text"
            v-model="wxaForm.wechat_slogan"
            :placeholder="$t('pages_wechat_configs_index_1175')"
          />
        </Form-item>
        <Form-item
          :label="$t('pages_wechat_configs_index_1160')"
          prop="background_image"
        >
          <uploader
            @uploadedUrl="uploadedBackground"
            :url="wxaForm.background_image"
          ></uploader>
        </Form-item>
        <Form-item
          :label="$t('pages_wechat_configs_index_1176')"
          prop="wechat_theme"
        >
          <Input type="color" v-model="wxaForm.wechat_theme" />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from "../../locales/index";

import { mapGetters, mapActions, mapState } from "vuex";
import Uploader from "@/components/uploader-aliyun/single";
import axios from "axios";
import { isApp } from "@/libs/util";

export default {
  components: {
    Uploader,
  },
  data() {
    return {
      modalShow: false,
      auth_url: "",
      iframeReady: false,
      wxaForm: {},
      showWxaModal: false,
    };
  },
  created() {
    this.find_one();
    this.getWxaWechat();
    window.addEventListener("message", this.listenMessage, false);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.listenMessage);
  },
  computed: {
    ...mapGetters("wechat_config", ["wechat_config"]),
    ...mapState("wxa_wechat", ["wxa_wechat"]),
    wxaAuthorized() {
      return this.wxa_wechat && Object.keys(this.wxa_wechat).length > 0;
    },
    iframeUrl() {
      const isProd = location.hostname.includes("chengbao68");
      return isProd
        ? "fresh-admin.chengbao68.com"
        : "fresh-admin.chengbao88.com";
    },
  },
  watch: {
    iframeReady(ready) {
      if (ready) {
        this.authorize();
      }
    },
  },
  methods: {
    ...mapActions("wechat_config", ["find_one", "show", "create", "update"]),
    ...mapActions("wxa_wechat", {
      getWxaWechat: "find_one",
      updateWxaWechat: "update",
    }),
    add() {
      this.modalShow = true;
    },
    listenMessage(e) {
      const data = e.data;
      if (data && data.ready) {
        this.iframeReady = true;
      }
    },
    initIframe() {
      const isProd = location.hostname.includes("chengbao68");
      const $window = this.$refs.iframe.contentWindow;
      let info = {};
      let token;
      const shopId = localStorage.getItem("SHOPID");
      try {
        info = JSON.parse(localStorage.getItem("session-info"));
        token = info.auth_token;
      } catch (e) {
        //
      }
      $window.postMessage(
        {
          type: "init",
          authorization: token,
          shopId: shopId,
          shopIdKey: "ShopId",
          prod: isProd,
          isChaibao: false,
        },
        "*"
      );
    },
    uploadedBackground(url) {
      this.wxaForm.background_image = url;
    },
    async authorize() {
      this.initIframe();
      const data = await axios.get("/wxa/componentloginpage");
      this.auth_url = data;
      const $window = this.$refs.iframe.contentWindow;
      $window.postMessage(
        {
          type: "setUrl",
          url: data,
          isChaibao: false,
          isApp: isApp(),
        },
        "*"
      );
    },
    async handleSubmit() {
      await this.update(this.wechat_config);
      this.modalShow = false;
    },
    async onEditWxa() {
      this.showWxaModal = true;
      this.form = { ...this.wxa_wechat };
    },
    async handleSubmitWxa() {
      await this.updateWxaWechat(this.wxaForm);
      this.showWxaModal = false;
    },
  },
};
</script>

<style scoped>
iframe {
  display: inline-block;
  width: 300px;
  height: 33px;
  border: none;
  overflow: hidden;
  margin-left: 12px;
  transform: translateY(12px);
}

.exa_empty {
  color: #999;
  text-align: center;
  padding: 30px 0;
}
</style>
